import React from 'react';

interface FormShimmerProps {
  rows?: number;
}

export const FormShimmer: React.FC<FormShimmerProps> = ({ rows = 6 }) => {
  return (
    <div className="animate-pulse space-y-6">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index}>
          {/* Label */}
          <div className="h-4 w-24 bg-gray-200 dark:bg-gray-700 rounded mb-2" />
          {/* Input */}
          <div className="h-10 w-full bg-gray-200 dark:bg-gray-700 rounded" />
        </div>
      ))}
      
      {/* Buttons */}
      <div className="flex gap-3 pt-4">
        <div className="h-10 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
        <div className="h-10 w-24 bg-gray-200 dark:bg-gray-700 rounded" />
      </div>
    </div>
  );
};
